export default "__VITE_ASSET__DwEtTf$f__"